module.exports = __webpack_public_path__ + "img/8.604b743a.jpg";